/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

export const createUrl = (filterId: string): string =>
	`/rest/api/3/filter/${filterId}?expand=subscriptions`;

const getAssociatedSubscription = (
	filterId: string,
): Promise<{
	subscriptions: {
		items: [];
	};
}> => fetchJson(createUrl(filterId));

export default getAssociatedSubscription;
